export default function RenderProps({ list, render }: any) {
  return list.map(render);
}
